// extracted by mini-css-extract-plugin
module.exports = {"Thumb":"ChapterPlayer_Thumb__3JLWy","ThumbZoom":"ChapterPlayer_ThumbZoom__1q0lT"};